import { MijnRoute } from '../../mijn-navigatie.model';

export const INCASSO_BATCHES: MijnRoute = {
    path: 'incassobatches',
    navigationEvent: 'toIncassobatches',
    regex: /^\/incassobatches$/,
    webcomponent: 'mijn-incassobatches-webcomponent'
};
